@if (order) {
  <div
    class="flex flex-col text-center"
    [class.h-screen]="fillViewport"
    [class.min-h-screen]="fillViewport"
  >
    @if (headerImage) {
      <div
        class="w-full shrink-0 bg-cover bg-center"
        [ngClass]="fillViewport ? 'h-[49vh]' : 'aspect-[3/2]'"
        [ngStyle]="{ 'background-image': 'url(' + headerImage.url + ')' }"
      ></div>
    }
    <div
      class="p-5 kiosk-xl:px-12 kiosk-xl:py-14"
      [ngClass]="
        fillViewport
          ? 'flex min-h-0 flex-1 flex-col'
          : 'flex flex-col'
      "
      [ngStyle]="getBackgroundStyles()"
    >
      <div
        [ngClass]="
          fillViewport
            ? 'flex min-h-0 flex-1 flex-col items-center justify-center overflow-y-auto'
            : 'flex flex-col items-center'
        "
      >
        @if (order.status === 'PAYMENT') {
          <div>
            <p class="mb-5 text-center text-3xl kiosk-xl:text-5xl">
              {{ 'kiosk-order-status.PAYMENT_IN_PROGRESS.title' | translate }}
            </p>
            <p class="mb-5 text-center text-3xl kiosk-xl:text-5xl">
              {{ 'kiosk-order-status.PAYMENT_IN_PROGRESS.loading' | translate }}
            </p>
          </div>
        }
        @if (order.status !== 'PAYMENT') {
          <div class="flex flex-col items-center gap-8">
            <div class="text-3xl font-bold kiosk-xl:text-5xl">
              {{ heading | translate }}
            </div>
            <div>
              <div
                class="order-number-fit-container"
                [class.order-number-fit-container--content-height]="!fillViewport"
              >
                <p
                  appFitText
                  [fitTextValue]="order.number"
                  [fitTextMinPx]="48"
                  [fitTextMaxPx]="192"
                  class="order-number-fit-text font-bold"
                >
                  {{ order.number }}
                </p>
              </div>
              @if (order.child_orders?.length) {
                <div>
                  @for (childOrder of order.child_orders; track childOrder) {
                    <div class="mb-8 md:mb-16">
                      <p
                        class="text-accent mb-5 text-center text-2xl font-bold text-neutral-800 md:text-4xl"
                      >
                        {{ childOrder.shop?.name }}
                      </p>
                      @if (childOrder.shop?.kiosk_additional_information) {
                        <p class="mb-5 text-center text-2xl md:text-4xl">
                          {{ childOrder.shop?.kiosk_additional_information }}
                        </p>
                      }
                    </div>
                  }
                </div>
              }
              @if (displayOrderReadyAt) {
                @if (order.ready_at) {
                  <p class="mb-5 text-center text-2xl md:text-4xl">
                    {{ 'kiosk-order-status.readyAt' | translate }}
                  </p>
                }
                @if (orderReadyAt) {
                  <p
                    class="text-accent mb-8 text-center text-4xl font-bold text-neutral-800 md:mb-16 md:text-7xl"
                  >
                    {{ orderReadyAt }}
                  </p>
                }
              }
            </div>
            @if (footer || footer1 || footer2 || logo?.url) {
              <div class="flex flex-col items-center gap-4">
                <div class="text-3xl font-bold kiosk-xl:text-5xl">
                  @if (footer) {
                    <p>{{ footer | translate }}</p>
                  }
                  @if (footer1) {
                    <p>{{ footer1 }}</p>
                  }
                  @if (footer2) {
                    <p class="mt-4">
                      <app-text-atom [content]="footer2"></app-text-atom>
                    </p>
                  }
                </div>
                @if (logo?.url) {
                  <img
                    [src]="logo?.url"
                    class="logo mt-12 max-w-28"
                    alt="img"
                    loading="lazy"
                  />
                }
              </div>
            }
          </div>
        }
      </div>
      <div class="flex w-full shrink-0 flex-col">
        <app-button-atom
          [label]="'kiosk-order-status.reset' | translate"
          type="kiosk-primary"
          [full]="true"
          [overrideBgColor]="buttonBackgroundColor"
          [overrideTextColor]="buttonTextColor"
          size="XXL"
          thickSize="XXL"
          (click)="goToHome()"
        ></app-button-atom>
      </div>
    </div>
  </div>
}
